import { Link } from 'react-router-dom'
import { ToolkitPageLayout } from 'toolkit/components/ToolkitPageLayout'
import { institution_relationship_placeholder } from 'assets' // Will be added later

const pageLinks = [
  {
    title: 'Champions',
    path: '/toolkit/institution/champions',
    image: institution_relationship_placeholder,
    altText: 'Placeholder image for Champions link'
  },
  {
    title: 'Audit & Feedback',
    path: '/toolkit/institution/audit-feedback',
    image: institution_relationship_placeholder,
    altText: 'Placeholder image for Audit & Feedback link'
  },
  {
    title: 'Extension for Community Health Outcomes (ECHO)',
    path: '/toolkit/providers/echo', // Link to existing Providers ECHO page
    image: institution_relationship_placeholder,
    altText: 'Placeholder image for ECHO link'
  }
]

export const InstitutionScdTeamEdRelationshipPage: React.FC = () => {
  const breadcrumbs = [
    { label: 'Toolkit', path: '/toolkit' },
    { label: 'Institution', path: '/toolkit/institution' },
    {
      label: 'SCD Team & ED Relationship',
      path: '/toolkit/institution/scd-team-ed-relationship'
    }
  ]

  return (
    <ToolkitPageLayout
      title="Sickle Cell Disease Team & Emergency Department Relationship"
      breadcrumbs={breadcrumbs}
    >
      <div className="container mx-auto px-4 py-8">
        <p className="text-lg text-gray-700 mb-8">
          The relationship between the Sickle Cell Disease (SCD) team and the
          Emergency Department (ED) is crucial for providing timely and
          effective care to individuals with SCD. This section provides
          resources to help foster this relationship.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {pageLinks.map((link) => (
            <Link
              key={link.title}
              to={link.path}
              className="block p-6 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 ease-in-out border border-gray-200"
            >
              <img
                src={link.image}
                alt={link.altText}
                className="w-full h-48 object-cover rounded-md mb-4"
              />
              <h3 className="text-xl font-semibold text-[#142841] mb-2">
                {link.title}
              </h3>
              <p className="text-sm text-[#3C2416] group-hover:text-[#A6410A]">
                Learn more
              </p>
            </Link>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/toolkit/institution"
            className="inline-block bg-[#A6410A] text-white font-semibold px-8 py-3 rounded-lg shadow-md hover:bg-[#C25F0C] transition-colors duration-300"
          >
            All done? Click here to return to the Institution screen
          </Link>
        </div>
      </div>
    </ToolkitPageLayout>
  )
}
